// api constants
export const API_TIMEOUT = 10000;
export const PING_IDENTITY_URL = "https://pingidentity.com";
export const HTTPS = "https://";
